import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/components/Footer.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const navigate = useNavigate();

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin-in',
      url: 'https://linkedin.com/company/dythel-consulting',
      target: '_blank'
    },
    {
      name: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      url: 'https://wa.me/260979788835',
      target: '_blank'
    },
    {
      name: 'Email',
      icon: 'fas fa-envelope',
      url: 'mailto:dythelconsulting@gmail.com',
      target: '_self'
    }
  ];

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Portfolio', path: '/portfolio' }
  ];

  const services = [
    'Research & Analysis',
    'Monitoring & Evaluation', 
    'Data Collection',
    'Capacity Building',
    'Translation Services'
  ];

  const handleHomeClick = (e) => {
    e.preventDefault();
    // Scroll to top and navigate home
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate('/'), 100);
  };

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      console.log('Subscribing email:', email);
      setIsSubscribed(true);
      setEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-brand">
            <h3 className="footer-logo">Dythel Consulting</h3>
            <p className="footer-tagline">Simplifying Service, Elevating Standards.</p>
            <p className="footer-description">
              Professional consulting services driving sustainable growth and organizational excellence across Zambia.
            </p>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.url}
                  className="social-link"
                  aria-label={social.name}
                  target={social.target}
                  rel={social.target === '_blank' ? 'noopener noreferrer' : ''}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-links-group">
            <div className="links-column">
              <h4>Navigation</h4>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    {link.name === 'Home' ? (
                      <a 
                        href="/" 
                        className="footer-link"
                        onClick={handleHomeClick}
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link to={link.path} className="footer-link">
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="links-column">
              <h4>Services</h4>
              <ul className="footer-links">
                {services.map((service, index) => (
                  <li key={index}>
                    <span className="footer-link">{service}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="links-column">
              <h4>Contact</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>Plot A2605, Meanwood Kwamwena,Lusaka, Zambia</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-phone"></i>
                  <span>Call Us +260979788835, +260966196623</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-envelope"></i>
                  <span>dythelconsulting@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter - Simple */}
        <div className="footer-newsletter">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h4>Stay Updated</h4>
              <p>Get insights and updates from our team</p>
            </div>
            {!isSubscribed ? (
              <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <input 
                  type="email" 
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-btn">
                  Subscribe
                </button>
              </form>
            ) : (
              <div className="newsletter-success">
                <i className="fas fa-check"></i>
                Thank you for subscribing!
              </div>
            )}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Dythel Consulting. All rights reserved.</p>
            <div className="legal-links">
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top */}
      <button 
        className="back-to-top"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </footer>
  );
};

export default Footer;